
// Services
import SEO from '~/services/seo'
import Provider from '~/services/provider'

// Mixins
import fetch from '~/mixins/fetch'
import gtm from '~/mixins/gtm.js'

// Utilities
import { head } from '~/utils/head'

export default {
  mixins: [fetch, gtm],

  data() {
    return {
      isLoading: process.env.RUNNING === 'test' ? false : true,
    }
  },

  head() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    const lang = this.$i18n.locale
    const url = `${process.env.BASE_URL}/${lang}/digital-learning`
    const canonical = `${process.env.BASE_URL}/${lang}/digital-learning`
    const title = this.$t('seo.home.title')
    const description = this.$t('seo.home.description')
    const general = this.$t('seo.shared.general')
    const facebook = this.$t('seo.shared.facebook')
    const twitter = this.$t('seo.shared.twitter')

    const payload = {
      routeName: this.$route.name,
      param: false,
      data: false,
    }

    return head({
      lang,
      htmlAttrs: { ...i18nHead.htmlAttrs },
      url,
      canonical,
      title,
      description,
      general,
      facebook,
      twitter,
      breadcrumbs: SEO.schema.breadcrumbs.getSchemaObj(this.breadcrumbs),
      link: SEO.linkAlternate.setList(payload),
    })
  },

  computed: {
    breadcrumbs() {
      const payload = {
        routePath: this.$route.path,
        dinamicValue: false,
      }
      const list = Provider.breadcrumbs.getItemList(payload)

      return list
    },
  },

  mounted() {
    this.isLoading = false
  },
}
